import React from 'react';

import Button from '@atlaskit/button/default/button';

const ButtonRovoExample = (): React.JSX.Element => {
	return <Button appearance="rovo">Rovo button</Button>;
};

export default ButtonRovoExample;
